export default __webpack_public_path__ + "static/media/40.b9fbbe29.jpeg";